import { render } from "./Responsive.vue?vue&type=template&id=5681a3ac"
import script from "./Responsive.vue?vue&type=script&lang=js"
export * from "./Responsive.vue?vue&type=script&lang=js"

import "./Responsive.vue?vue&type=style&index=0&id=5681a3ac&lang=css"
script.render = render

export default script